/**
 * Created by rickborst on 24/02/2017.
 */

export { default as session } from "./session";
export { default as user } from "./user";
export { default as paymentDetails } from "./paymentdetails";
export { default as viewTree } from "./viewtree";
export { default as asset } from "./asset";
export { default as linearchannels } from "./linearchannels";
export { default as payment } from "./payment";
export { default as miniepg } from "./modules/miniepg";
export { default as device } from "./device";
export { default as landingPage } from "./landing";
export { default as imagesqueue } from "./imagesqueue";

export { default as player } from "./widgets/player";
export { default as header } from "./widgets/header";
export { default as navigation } from "./widgets/navigation";

export { default as modal } from "./modal";
export { default as dialog } from "./modals/dialog";
export { default as login } from "./modals/login";
export { default as forgotPassword } from "./modals/forgotpassword";
export { default as resetPassword } from "./modals/resetpassword";
export { default as confirm } from "./modals/confirm";
export { default as setreminder } from "./modals/setreminder";
export { default as register } from "./modals/register";
export { default as edituser } from "./modals/edituser";

export { default as series } from "./pages/series";
export { default as settings } from "./pages/settings";
export { default as paymentHistory } from "./pages/paymenthistory";
export { default as connectCode } from "./pages/connect";
export { default as successPage } from "./successPage";
export { default as loader } from "./loader";
export { default as seasonRegistration } from "./seasonregistration";
export { default as promotionPopupConfig } from "./promotionpopupconfig";
export { default as newRegistration } from "./newRegistration";
export { default as config } from "./config";
export { default as splashScreen } from "./splashScreen";



// WEBPACK FOOTER //
// ./src/js/store/reducers/index.js